import React from "react";

import { CalendarWeek as CalendarIcon, Clock } from "flowbite-react-icons/outline";
import CloseIcon from "../../../../components/Icons/CloseIcon";
import InformationCircleIcon from "../../../../components/Icons/InformationCircleIcon";
import {
  dateFormatDate,
  dateFormatHourMinute,
} from "../../../../helpers/dateFunctions";

interface BannerProps {
  selectedDate: Date;
  coachName?: string;
  title: string;
  close: Function;
}

const Banner: React.FC<BannerProps> = ({
  selectedDate,
  coachName,
  title,
  close,
}) => {
  return (
    <div
      className={`flex flex-col gap-4 bg-gray-200 text-indigo-1000 rounded-md border border-transparent p-4`}
    >
      {/* HEADER */}
      <div className="flex flex-row justify-between gap-2 align-middle items-center">
        <InformationCircleIcon variant="gray" alt="calendar icon" className="w-6 h-6" />
        <p className="z-title2 grow">{title}</p>
        <CloseIcon aria-label="Close banner" className="w-6 h-6 cursor-pointer text-neutral-900!" onClick={() => close()} />
      </div>
      {/* BODY */}
      <div className="flex flex-row justify-between gap-2 items-center">
        <p className="z-title3 grow">{coachName}</p>

        <div className="flex flex-row gap-1 items-center">
          <CalendarIcon className="w-6 h-6" aria-hidden="true" />
          <p className="z-title3 text-center">
            {dateFormatDate(selectedDate, false, "sv")}
          </p>
        </div>
        <div className="flex flex-row gap-1 items-center">
          <Clock className="w-6 h-6" aria-hidden="true" />
          <p className="z-title3 text-center">
            {dateFormatHourMinute(selectedDate)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Banner;
